import React, { useState, useEffect } from "react";
import { Input, Text } from "@fragments";
import { Person as PersonIcon } from "@mui/icons-material";
import { UserAvatar } from "@components/Community";
import api from "@helpers/api";
import { useAuth } from "@contexts/AuthContext";

export default function LessonOwner({ value, onChange, community }) {
    const { user } = useAuth();
    const [owners, setOwners] = useState([]);
    const [loading, setLoading] = useState(false);

    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleUpdate = (val) => {
        setLocalValue(val);
        onChange?.(val);
    };

    useEffect(() => {
        fetchCommunityAdmins();
    }, []);

    useEffect(() => {
        console.log(localValue, owners, user)
        if (owners.length > 0 && !localValue) {
            const defaultOwner = owners.find(o => o.id === user?.id) || owners[0];
            handleUpdate(defaultOwner.id);
        }
    }, [owners, localValue, user?.id]);

    const fetchCommunityAdmins = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("community/member/permission?permission=admin&community=" + community);

            const admins = Array.isArray(data) ? data : [];
            let updatedOwners = admins;
            if (user && !admins.some(o => o.id === user.id)) {
                updatedOwners = [user, ...admins];
                setOwners(updatedOwners);
            } else {
                setOwners(admins);
            }

            if (updatedOwners.length > 0 && !localValue) {
                const defaultOwner = updatedOwners.find(o => o.id === user?.id) || updatedOwners[0];
                handleUpdate(defaultOwner.id);
            }
        } catch (error) {
            console.error("Error fetching community admins:", error);
            setOwners([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return null;

    if (owners.length === 0) return null;

    const selectedOwner = owners.find(o => o.id === parseInt(localValue));

    const options = owners.map(owner => ({
        label: owner.username,
        value: owner.id,
        icon: <UserAvatar user={owner} size={24} />
    }));

    return (
        <>
            <Text.h5
                left={<PersonIcon />}
                value="Proprietário do vídeo"
                className="mb-1"
            />
            <Input.Select
                key={owners?.length}
                value={localValue}
                onInput={handleUpdate}
                options={options}
                start={selectedOwner ? <UserAvatar user={selectedOwner} size={24} /> : <PersonIcon />}
            />
        </>
    );
}
